import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'tool-header',
  templateUrl: './tool-header.component.html',
  styleUrls: ['./tool-header.component.scss']
})
export class ToolHeaderComponent implements OnInit{

  @Input() langLabel: string = "";
  @Output() langClick = new EventEmitter();
  ngOnInit() {

  }
 languageSwitch(event: any) {
    this.langLabel = event;
    this.langClick.emit(event);
  }

}
